module.exports = __webpack_public_path__ + "static/media/icon-warning.da5e989b.svg";